export default "__VITE_ASSET__CXenJ$l1__"